import { Route, Switch } from "react-router";
import ErrorBoundary from "./components/ErrorBoundary";
// routes
import Main from "./Main";
import Contracting from "./Contracting";
import Equipments from "./Equipments";
import { Provider } from "react-redux";
import { contractingStore, equipmentsStore, publicStore } from "./redux/store";

function App() {
  return (
    <div className="App">
      <Switch>
        <Route path="/contracting">
          <ErrorBoundary>
            <Provider store={contractingStore}>
              <Contracting />
            </Provider>
          </ErrorBoundary>
        </Route>
        <Route path="/equipments">
          <ErrorBoundary>
            <Provider store={equipmentsStore}>
              <Equipments />
            </Provider>
          </ErrorBoundary>
        </Route>
        <Route path="/">
          <ErrorBoundary>
            <Provider store={publicStore}>
              <Main />
            </Provider>
          </ErrorBoundary>
        </Route>
      </Switch>
    </div>
  );
}

export default App;
